import { asset } from "@/lib/asset";
import ul from '../../assets/icons/ul.svg';

export const KAMobile = () => {
    return (
        <div className='w-full mx-auto max-w-[460px] h-[1022px] flex flex-col justify-between items-between'>
            <div className="flex flex-col justify-center items-center w-full h-40 mt-[79px]">
                <img className="w-40 h-28" src={asset("/img/ka.svg")} />
            </div>
            <div className="flex flex-col justify-center items-center gap-10 ">
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 text-right justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 text-right justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 text-right justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
                <div className="w-[14rem] sm-w-20rem flex flex-col justify-start items-center gap-3.5">
                    <div className="w-[14rem] sm-w-20rem h-14 justify-start text-white text-[10px] font-normal font-['Open_Sans']">Компоненты системынастраиваются автоматически безизменения конфигурации или кода,а возможность наблюдения заданными начинается немедленно.<br/>Для удобства сопровождения</div>
                </div>
            </div>

            <div className="w-full max-w-[460px] relative">
                {/* top left bullet  */}
                <img src={ul} alt="ul" className='w-9 h-5 object-contain absolute top-[-875px] left-[74px]' />
                {/* top right bullet  */}
                <img src={ul} alt="ul" className='w-9 h-5 object-contain absolute top-[-875px] right-[74px] transform rotate-[-180deg]' />

                {/* top left horizontal lines  */}
                <hr className='w-14 h-[1.5px] bg-[#fed7aa] absolute mt-[-865px] left-[18px]' />
                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute left-[18px] mt-[-680px]' />

                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute left-[18px] mt-[-480px]' />

                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute left-[18px] mt-[-290px]' />

                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute left-[18px] mt-[-97px]' />
                
                {/* right horizontal lines */}
                <hr className='w-14 h-[1.5px] bg-[#fed7aa] absolute mt-[-865px] right-[17px]' />
                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute right-[17px] mt-[-580px]' />

                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute right-[17px] mt-[-380px]' />

                <hr className='w-6 h-[1.5px] bg-[#fed7aa] absolute right-[17px] mt-[-190px]' />

                

                {/* vertical lines */}
                {/* left line  */}
                <hr className='w-[768px] h-[1.5px] bg-[#fed7aa] rotate-90 left-[-365px] absolute mt-[-480px]' />
                {/* right line  */}
                <hr className='w-[675px] h-[1.5px] bg-[#fed7aa] rotate-90 right-[-320px] absolute mt-[-528px]' />
            </div>
        </div>
    );
};

export default KAMobile;